// extracted by mini-css-extract-plugin
export default {"container":"highlight-module__container--lU94a"};